import * as types from '../types/basket';
import * as _ from 'lodash';

const removeProduct = function(array, obj) {
  array.splice(obj.index, 1);
  return array;
};

const updateProduct = function(array, action) {
  const index = action.data.index;
  let item = array[index];
  delete action.data.index;
  item = _.assign(item, action.data);
  array[index] = item;
  return array;
  // return array.map((item, index) => {
  //   if (index !== action.data.index) {
  //     return item;
  //   }
  //
  //   return {
  //     ...item,
  //     ...action.data,
  //   };
  // });
};

export default function Basket(state = {
  openedBasket: false,
  list: [],
}, action) {
  switch (action.type) {
    case types.BASKET_ADD:
      return {
        ...state,
        list: [
          ...state.list,
          {
            index: state.list.length,
            ...action.data,
          },
        ]
      };
    case types.BASKET_REMOVE_PRODUCT:
      return {
        ...state,
        list: removeProduct(state.list, action.data),
      };
    case types.BASKET_UPDATE:
      return {
        ...state,
        list: updateProduct(state.list, action),
      };
    case types.BASKET_CLEAR:
      return {
        ...state,
        list: []
      };
    case types.OPEN_BASKET:
      return {
        ...state,
        openedBasket: true,
      };
    case types.CLOSE_BASKET:
      return {
        ...state,
        openedBasket: false,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/basket.js